import type { FC, ReactNode } from 'react';
import { useAppInit } from '@/hooks/init';
import { useAuth0 } from '@auth0/auth0-react';
import CenteredSpin from '@/components/CenteredSpin';

const AppGuard: FC<{ children: ReactNode }> = ({ children }) => {
  const { isLoading: appInitLoading } = useAppInit();
  const { isLoading: auth0Loading } = useAuth0();
  const isLoading = appInitLoading || auth0Loading;

  if (isLoading) {
    return <CenteredSpin />;
  }

  return <>{children}</>;
};

export default AppGuard;
